/**
* DevExpress Analytics (core\utils\_debug.js)
* Version:  23.1.6
* Build date: Oct 17, 2023
* Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
export var DEBUG = false;
export function DebugMode(value) {
    DEBUG = value;
}
